// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8b2c0c7e","453":"e2360db7","586":"18cb3b08","653":"742674b8","667":"819d4416","745":"2331efd6","800":"6f634524","884":"cca5b849","977":"b340e4fa"}[chunkId] + ".chunk.js";
};